import { getMobileAppShellPolicy } from "../components/Controller/appShellPolicy.ts";
import { isMobileCoreLoopV4Enabled } from "../util/mobileCoreLoopFeatureFlag.ts";
import { isMobileIAV3Enabled } from "../util/mobileIAFeatureFlag.ts";
import { useLocalPartial } from "../util/local.ts";
import { useViewData } from "../util/viewManager.tsx";

export const useMobileBottomChrome = () => {
	const viewInfo = useViewData();
	const { lid } = useLocalPartial(["lid"]);
	const inLeague = !!viewInfo?.inLeague && lid !== undefined;
	const pageID: unknown = viewInfo?.idLoading ?? viewInfo?.idLoaded;

	return getMobileAppShellPolicy({
		inLeague,
		mobileCoreLoopV4Enabled: isMobileCoreLoopV4Enabled(),
		mobileIAV3Enabled: isMobileIAV3Enabled(),
		pageID,
	}).bodyBottomChrome;
};
